import styled from 'styled-components'

export interface QAComponentType {
  inQA: boolean
  inQAEdit: boolean
  disableHover?: boolean
  isFocused?: boolean
}

// QA component styles are kinda weird, change how we insert `.focused` to components
export const generateQAComponentStyles = ({
  inQA,
  inQAEdit,
  disableHover = false,
  isFocused = false
}: QAComponentType): string | undefined => {
  const highlightedStyles = `
    outline: none;
    cursor: pointer;

    .ant-input,
    .ant-input-disabled,
    .ant-select-selector,
    .ant-select-selection-item,
    .ant-select-selection-placeholder,
    .ant-select-arrow,
    .ant-input,
    .ant-picker,
    .ant-picker-input > input,
    .ant-picker-disabled,
    .ant-picker-suffix,
    .ant-checkbox-wrapper > span,
    .ant-checkbox > span,
    .ant-btn&:not(.ant-btn-text),
    .ant-input-number-input,
    .ant-input-number-disabled {
      border-color: #175CD3;
      color: #175CD3;

      &::placeholder {
        border-color: #175CD3;
        color: #175CD3;
      }
    }

    .ant-collapse,
    .ant-collapse-item,
    .ant-collapse-content {
      border-color: #175CD3;
    }

    .ant-typography, .ant-btn-text {
      color: #175CD3;
      strong {
        color: #175CD3;
      }
    } 

    .ant-radio-wrapper .ant-radio + span {
      color: #175CD3;

    }

    .ant-radio-inner {
      ${
        inQA &&
        `::after {
        background-color: #175CD3;
        }`
      }
      
      border-color: #175CD3;
    }

    .question-container-dependent {
      border-color: #175CD3;
      color: #175CD3;
    }
  `

  const qaComponentStyles: string[] = []

  if (inQA && !disableHover) {
    qaComponentStyles.push(`&:hover {
      ${highlightedStyles}
    }`)
  }
  if ((inQA || inQAEdit) && isFocused) {
    // The nth-of-type(n) is a hack to add selector specificity to CSS in order
    // to make these highlighted styles important enough to override other
    // styles.
    qaComponentStyles.push(`:nth-of-type(n) {
      ${highlightedStyles}
    `)
  }

  return qaComponentStyles.join('\n')
}

export const ItemWithTextDetailsContainer = styled.div<QAComponentType>`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 30px 0px;
  gap: 48px;
  color: black;
  .ant-form-item {
    margin-bottom: 0;
  }

  ${(qaComponentProps) => generateQAComponentStyles(qaComponentProps)}
`
export const ItemWithConditionalQuestions = styled.div<QAComponentType>`
  display: flex;
  flex-direction: column;
  color: black;
  .ant-form-item {
    margin-bottom: 0;
  }
  ${(qaComponentProps) => generateQAComponentStyles(qaComponentProps)}
`

export const HalfWidthContainer = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const SpacedRows = styled.div`
  display: flex;
  align-items: center;
  margin: 1rem 0;
  .ant-form-item {
    margin-bottom: 0;
  }
`
